import React from 'react';

import './styles/logo.scss';

import LogoImage from '@images/logo.png';
import LangA from '../../i18n/LangA';
import CloudflareImage from '../cloudflare-image/CloudflareImage';

const Logo = ({ id }) => {
  return (
    <LangA href="/" className="logo" title="Zerobounce">
      <CloudflareImage id={id} src={LogoImage} alt="Footer Zerobounce" width="157" height="45" />

      <span className="hidden">Zero Bounce</span>
    </LangA>
  );
};

export default Logo;
